
import { sound, Sound } from "@pixi/sound";
// import { Group } from "tweedle.js";
import { Assets } from "pixi.js";
import { Tween } from "tweedle.js";
import { GameIntroComponent } from "../components/gameIntro/GameIntroComponent";
import { LogoComponent } from "../components/logo/LogoComponent";
import { Meter } from "../components/meter/Meter";
import { MeterComponent } from "../components/meter/MeterComponent";
import { ReelComponent } from "../components/reels/ReelsComponent";
import { RIPFeatureComponent } from "../components/rip/RIPFeatureComponent";
import { WinMeterComponent } from "../components/winmeters/WinMeterComponent";
import { currentBackgorundMusicVolume, isGameAlreadyLoaded, isMusicBtnOnGlobal, RespinIndex, setBackgorundMusic, setIsGameAlreadyLoaded, setMaxWinBtnClosedGlobal, willBannerAutoProceedGlobal } from "../config/GlobalVariableConfig";
import { CasinoChannelHandler, casinoEventEmitter } from "../core/CasinoChannelHandler";
import { Manager } from "../core/Manager";
import { DisplayComponent } from "../core/displays/DisplayComponent";
import { DisplayComponentFactory } from "../core/displays/DisplayComponentFactory";
import { EventConstants } from "../gameClientEvents/EventConstants";
import { GameEvents } from "../gameClientEvents/GameEvents";
import { SoundConstants } from "../gameClientEvents/SoundConstants";
import { reelSpinEmitter } from "../reels/ReelInit";
import { spinData } from "../server/getServerResposesFun";
import { BaseScene } from "./BaseScene";
import { BigWin } from "./BigWin";
import { FreeGameScene } from "./FreeGameScene";

// const tweenGroup: Group = new Group();

export class BaseGameScene extends BaseScene {
    private backgroundMusic: Sound | null = null;

    private freSpinTrigger: number = 0;
    private freSpinTriggerBaseWin: number = 0;

    private freeGameScene: FreeGameScene | null = null;

    private autoTriggerTimeout: ReturnType<typeof setTimeout>;

    private pointerDownHandlerBase: () => void;

    private lineToggleTimeout: ReturnType<typeof setTimeout>;
    private togglePlay: boolean = false;
    constructor() {
        super();

        this.setupEventListeners();

        this.pointerDownHandlerBase = this.onPointerDown.bind(this);
    }

    private setupEventListeners(): void {
        // casinoEventEmitter.on('roundEnded', this.handleRoundEnded.bind(this));
        casinoEventEmitter.on('roundStarted', this.handleRoundStarted.bind(this));
        casinoEventEmitter.on('betChanged', this.handleBetChanged.bind(this));
        GameEvents.emitter.on(EventConstants.GAME_INTRO_COMPLETE, this.onIntroComplete, this);
        reelSpinEmitter.off('triggerFeature', this.handleFeature, this);

        reelSpinEmitter.on('triggerFeature', this.handleFeature, this);

    }

    private async handleFeature(): Promise<void> {
        return new Promise(async(resolve) => {
            if (spinData.respins[RespinIndex.value].type === "rip_activated") {
                console.log("rip activated");
                // await sound.play(SoundConstants.RIP_SYMBOL,{volume: 1});
                DisplayComponent.get(RIPFeatureComponent).startFeature(() => {
                    resolve();
                });
            } else {
                resolve();
            }
        });
    }

    private async handleRoundStarted() {
        DisplayComponent.get(RIPFeatureComponent).visibilityCheckForCollectMeter = true;
        if (DisplayComponent.get(RIPFeatureComponent).visibilityCheck) {
            DisplayComponent.get(WinMeterComponent).getInstance().hideCollectMeter();
            DisplayComponent.get(RIPFeatureComponent).visibilityCheck = false;
        }
        this.spinReel();
    }

    private handleBetChanged() {
        console.log('BaseGameScene - betChanged:');
        this.resetToggleTimeout();
        this.reels.resetWinsOnBetChange();
    }

    private onPointerDown(): void {
        clearTimeout(this.autoTriggerTimeout);
        console.log("calling freeGameSceneChnage pointerdown");
        this.freeGameSceneChange();

        Manager.banner.off('pointerdown', this.pointerDownHandlerBase);
    }

    private setupBGSound() {
        this.backgroundMusic = sound.find(SoundConstants.BASE_MUSIC); // initialize with ambient sound
        setBackgorundMusic(this.backgroundMusic);

        if (this.backgroundMusic) {
            this.backgroundMusic.loop = true;
            // this.backgroundMusic.volume = 1;//currentBackgorundMusicVolume;
            // console.log("this.backgroundMusic.volume", this.backgroundMusic.volume);
            this.backgroundMusic.singleInstance = true;
            // this.backgroundMusic.speed = 0.5;
            this.backgroundMusic.play();

            this.backgroundMusic.muted = !isMusicBtnOnGlobal;

            new Tween(this.backgroundMusic)
                .to({ volume: currentBackgorundMusicVolume }, 2000)
                .start();
        }
    }

    private callFreeGameSceneChangeAuto() {

        this.autoTriggerTimeout = setTimeout(() => {
            console.log("calling freeGameSceneChnage auto")
            clearTimeout(this.autoTriggerTimeout);
            this.freeGameSceneChange();
        }, 10000); // 10 seconds
    }

    private resetToggleTimeout() {
        clearTimeout(this.lineToggleTimeout);
        this.lineToggleTimeout = undefined;
        this.togglePlay = false;
    }

    private async spinReel(): Promise<void> {

        // Cancel any previously scheduled lineToggle
        this.resetToggleTimeout();
        sound.play(SoundConstants.BUTTON_CLICK,{ volume: 1 });

        if (this.reels) {

            const [freeGameTrigger, winAmount, accumulatedWins, isFeatureTrigger] = await this.reels.startPlay("BASE");
            console.log("in BaseGameScene freeGameTrigger winAmount RespinIndex.value", freeGameTrigger, winAmount, accumulatedWins, RespinIndex.value, isFeatureTrigger);
            if (isFeatureTrigger) {
                await this.handleFeature();
                RespinIndex.increase();
            }

            if (freeGameTrigger > 0 && Manager.banner) {

                this.freSpinTrigger = freeGameTrigger;
                this.freSpinTriggerBaseWin = winAmount;

                await this.reels?.processWinFeatureSymbol();

                Manager.casinoChannelHandler.reportFeatureEnter();

                await Manager.banner.appearFreeGameIntroBanner(this.freSpinTrigger);

                console.log("appearFreeGameIntroBanner");

                if (willBannerAutoProceedGlobal) {
                    this.callFreeGameSceneChangeAuto();
                }

                this.freeGameScene = new FreeGameScene(this.freSpinTrigger, this.freSpinTriggerBaseWin);
                await Manager.changeScene(this.freeGameScene, false);

                //attach a listner now
                Manager.banner.on('pointerdown', this.pointerDownHandlerBase);

            }
            else if (winAmount === -1) {
                console.log("in Gamescene- Bet declined");
            }
            else {
                await this.bigWin?.bigWinFunction(winAmount);
                Manager.casinoChannelHandler.reportGameRoundCompleted();
                DisplayComponent.get(LogoComponent).resetLogoPositionAfterRIPFeature();
                this.togglePlay = true;
                DisplayComponent.get(RIPFeatureComponent).tintRemovalAfterRoundCompleted();
            }

            if (freeGameTrigger === -2 || spinData.respins[RespinIndex.value]?.type === "max_win_reached") { // max win reached 
                setMaxWinBtnClosedGlobal(false);
                Manager.casinoChannelHandler.reportMaxWin();
            }


            if (this.togglePlay && winAmount > 0) {
                this.lineToggleTimeout = setTimeout(() => {
                    this.reels.lineToggle(0); // for toggle respin index will always be 0
                }, 1000);
            }

            console.log("gggg")

        }
    }

    private async freeGameSceneChange() {
        await Manager.banner?.disappearBanner();

        this.freeGameScene?.freeSpinPlay();
    }

    private onIntroComplete() {
        this.reelFrame.alpha = 1;
        this.backgroundImageCont.alpha = 1;
        this.backgroundSpine.alpha = 1;
        (DisplayComponent.get(MeterComponent).getInstance() as Meter).show();
        this.setupBGSound();
        CasinoChannelHandler.reportGameStarted();
        setIsGameAlreadyLoaded(true);
    }

    public async constructorWithAssets(): Promise<void> {
        this.initBaseLayering('background', 'baseBackgroundSkel', 'baseBackgroundAtlas');
        DisplayComponent.register(new DisplayComponentFactory(ReelComponent));
        DisplayComponent.get(ReelComponent).init();
        this.reels = DisplayComponent.get(ReelComponent).getInstance();
        this.setupReelFrame("reelBackSkel", "reelBackAtlas", !isGameAlreadyLoaded);
        this.setupCommonUI();

        if (!isGameAlreadyLoaded) {
            this.addComponent(GameIntroComponent, this);
        } else {
            (DisplayComponent.get(MeterComponent).getInstance() as Meter).show();
        }

        this.bigWin = new BigWin(Manager.screenwidth, Manager.screenHeight);
        this.addChild(this.bigWin);

        this.resize(Manager.screenwidth, Manager.screenHeight);
    }

    public override destroy() {
        casinoEventEmitter.removeAllListeners('roundStarted');
        casinoEventEmitter.removeAllListeners('betChanged');

        reelSpinEmitter.off('triggerFeature', this.handleFeature, this);

        GameEvents.emitter.off(EventConstants.GAME_INTRO_COMPLETE, this.onIntroComplete, this);
        DisplayComponent.unregister(GameIntroComponent);
        Assets.unload(['gameIntroSkel', 'gameIntroAtlas', 'baseBackgroundSkel', 'baseBackgroundAtlas']);
        super.destroy();
    }
}
